// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
  	
};

// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
    var content = '';
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm != null) {
        var content = bcSfFilterConfig.label.search_result_number_other;
        if (data.total_product <= 1) {
            var content = bcSfFilterConfig.label.search_result_number_one;
        }
        content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
    }
    jQ('.' + this.class.searchResultNumber).html(content);
  
  	if(data.total_product == 0){
      	jQ('.template-search .contact-form').show();
    } else {
      	jQ('.template-search .contact-form').hide();
    }
};

// Build Products
BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';

    // Buid Header
    result += this.buildSuggestionHeader(itemInfo['label'], 'product');

    // Build Did you mean
    var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
    if (dym != '') {
        result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
    }

    // Build content
    if (Object.keys(itemData).length > 0) {
        var count = 0;
        for (var k in itemData) {
            if (count < itemInfo['number']) {
                var product = itemData[k];
                if (this.getSettingValue('search.productAvailable') === false || 
                    (this.getSettingValue('search.productAvailable') && product.available)) {
                    // Get product attributes
                    var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, suggestionData);
                    productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
                    var productUrl = this.buildProductItemUrl(product, false);
                    var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], 'medium') : bcSfFilterConfig.general.no_image_url;
                    var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
                    // Get custom class / attribute
                    var searchSuggestionClass = this.class.searchSuggestion;
                    var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

                    result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
                    result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
                    // Build Left column
                    if (this.getSettingValue('search.showSuggestionProductImage')) {
                        result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
                    }
                    result += '</a>'; // End a
                    // Build Right column
                    result += '<div class="' + searchSuggestionClass + '-right">';
                    result += '<div class="' + searchSuggestionClass + '-product-title"><a href="' + productUrl + '" ' + newTabAttr + '>' + productTitle + '</a></div>';
                    if (this.getSettingValue('search.showSuggestionProductSku')) {
                        result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
                    }
                    if (this.getSettingValue('search.showSuggestionProductVendor')) {
                        result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
                    }
                  	result += this.buildSuggestionProductPrice(product);
                  
                  	result += '<form action="/cart/add" method="post" enctype="multipart/form-data" class="product-form product-form-search" data-section="search">';
                    result += '<select name="id" id="ProductSelect-search" data-section="search" class="product-form__variants no-js">';
                    if (!product.available) {
                        result += '<option disabled="disabled">' + product.variants[0]['title'] + ' - sold out</option>';
                    } else {
                        result += '<option selected="selected" value="' + product.variants[0]['id'] + '">';
                        result += product.variants[0]['title'];
                        result += '</option>';
                    }
                    result += '</select>';
                    result += '<div class="product-form__item product-form__item--quantity">';
                    result += '<input type="number" id="Quantity-' + k + '" name="quantity" value="1" min="1" class="product-form__input" pattern="[0-9]*" aria-label="Quantity">';
                    result += '</div>';
                    result += '<div class="product-form__item product-form__item--submit">';
                    if (!product.available) {
                        result += '<button type="submit" name="add" id="AddToCart-search" disabled="disabled" class="btn product-form__cart-submit product-form__cart-submit--small">';
                    } else {
                        result += '<button type="submit" name="add" id="AddToCart-search" class="btn product-form__cart-submit product-form__cart-submit--small">'; 
                    }
                    result += '<span id="AddToCartText-search">';
                    if (!product.available) {
                        result += 'Sold out';
                    } else {
                        result += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 37 40"><path d="M36.5 34.8L33.3 8h-5.9C26.7 3.9 23 .8 18.5.8S10.3 3.9 9.6 8H3.7L.5 34.8c-.2 1.5.4 2.4.9 3 .5.5 1.4 1.2 3.1 1.2h28c1.3 0 2.4-.4 3.1-1.3.7-.7 1-1.8.9-2.9zm-18-30c2.2 0 4.1 1.4 4.7 3.2h-9.5c.7-1.9 2.6-3.2 4.8-3.2zM4.5 35l2.8-23h2.2v3c0 1.1.9 2 2 2s2-.9 2-2v-3h10v3c0 1.1.9 2 2 2s2-.9 2-2v-3h2.2l2.8 23h-28z"/></svg>';
                    }
                    result += '</span>';
                    result += '</button>';
                    result += '</div>';
                    result += '</form>';
                  
                  	//result += '<form action="/cart/add" method="post" enctype="multipart/form-data" class="product-form product-form-product-template" data-section="product-template"> <input id="warehouse-code" type="hidden" name="properties[_Warehouse Code]" value=""> <div class="product-form__item product-form__item--submit"> <button type="submit" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit product-form__cart-submit--small"> <span id="AddToCartText-product-template"> Lisää ostoskoriin </span> </button> </div> </form>';
                    result += '</div>'; // End Right column
                  	
                    result += '</li>';  // End li

                    count ++;
                }
            } else break;
        }
    }
    return result;
};